"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _popupManagement = require("@/api/operationManagement/popupManagement");
var _PopupOperation = _interopRequireDefault(require("./components/PopupOperation.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PopupManagement',
  components: {
    PopupOperation: _PopupOperation.default
  },
  data: function data() {
    return {
      pagination: {
        total: 0 // 条数
      },
      queryData: {
        popupName: '',
        popType: '',
        region: '',
        enable: '',
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: []
    };
  },
  created: function created() {
    this.pageListApi();
  },
  methods: {
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.pageListApi();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        popupName: '',
        region: '',
        enable: '',
        page: {
          page: 1,
          size: 10
        }
      };
      this.pageListApi();
    },
    onAddPopup: function onAddPopup() {
      this.$refs.PopupOperation.open({
        type: 'add',
        name: '新增弹窗'
      });
    },
    onDetail: function onDetail(data) {
      this.$refs.PopupOperation.open({
        type: 'editor',
        name: '编辑弹窗',
        id: data.id
      });
    },
    // 删除
    onDel: function onDel(data) {
      var _this = this;
      this.$confirm('是否确认删除此弹窗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteByIdApi(data.id);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.pageListApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.pageListApi();
    },
    onRefresh: function onRefresh() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.pageListApi();
    },
    pageListApi: function () {
      var _pageListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _popupManagement.pageListApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                // console.log('res', res.data.data)
                this.tableData = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function pageListApi() {
        return _pageListApi2.apply(this, arguments);
      }
      return pageListApi;
    }(),
    deleteByIdApi: function () {
      var _deleteByIdApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: id
              };
              _context2.n = 1;
              return (0, _popupManagement.deleteByIdApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              this.pageListApi();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteByIdApi(_x) {
        return _deleteByIdApi2.apply(this, arguments);
      }
      return deleteByIdApi;
    }()
  }
};